module.exports = __webpack_public_path__ + "media/4x3/ru-0cacf46e.svg";